<template>
  <div class="simple-selector" ref="selectorContainer">
    <button 
      class="selector-trigger"
      @click="toggleDropdown"
    >
      <div class="selector-content">
        <div class="current-element">
          <div class="element-icon" v-html="currentElementIcon"></div>
          <span class="element-label">{{ currentElementLabel }}</span>
        </div>
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.645 -7.19052e-08L-2.83151e-07 1.52227L7 8L14 1.52227L12.355 -5.40054e-07L7 4.94467L1.645 -7.19052e-08Z" fill="#374957"/>
        </svg>
      </div>
    </button>
    
    <!-- Dropdown List -->
    <div v-if="isDropdownOpen" class="dropdown-list">
      <div class="scroll-area">
        <!-- <template v-for="(category, index) in categories" :key="category.name"> -->
          <!-- Category Divider -->
          <!-- <div class="category-divider">
            <div class="divider-line"></div>
            <span class="category-label">{{ category.label }}</span>
            <div class="divider-line"></div>
          </div> -->
          
          <!-- Category Options -->
          <button 
            v-for="(ele, index) in elements" 
            :key="ele.value" 
            class="dropdown-option"
            @click.stop="selectElement(ele)"
          >
            <div class="element-icon" v-html="ele.iconSvg"></div>
            <span class="element-label">{{ ele.label }}</span>
          </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleSelector',
  props: {
    currentElementType: {
      type: [String, Number, Object],
      default: ''
    },
    elements: {
      type: Array,
      required: true,
      // Expected format:
      // [
      //   {
      //     value: 'basic_elements',
      //     label: 'Basic Elements',
      //   },
      //   ...
      // ]
    }
  },
  emits: ['element-selected', 'update:currentElementType'],
  data() {
    return {
      isDropdownOpen: false
    };
  },
  computed: {
    currentElement() {
      const found = this.elements.find(el => {
        // Handle array values (deep comparison)
        if (typeof el.value === 'object' && typeof this.currentElementType === 'object') {
          return JSON.stringify(el.value) === JSON.stringify(this.currentElementType);
        }
        // Handle simple value comparison
        return el.value === this.currentElementType;
      });
      if (found) return found;
      
      return this.elements[0] || null;
    },
    currentElementLabel() {
      return this.currentElement?.label || 'Select Element';
    },
    currentElementIcon() {
      return this.currentElement?.iconSvg || '';
    }
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectElement(element) {
      this.isDropdownOpen = false;
      this.$emit('element-selected', element);
      this.$emit('update:currentElementType', element.value);
    },
    handleClickOutside(e) {
      if (this.$refs.selectorContainer && !this.$refs.selectorContainer.contains(e.target)) {
        this.isDropdownOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.simple-selector {
  width: 100%;
  min-width: fit-content;
  position: relative;
}

.selector-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 200px;
  height: 40px;
  padding: 8px 16px;
  background: white;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
  z-index: 1001;
}
.selector-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
}

.selector-trigger:hover .selector-content {
  background: #f2f2f2;
  border-radius: 4px;
}

.current-element {
  display: flex;
  align-items: center;
  gap: 4px;
  height: fit-content;
  flex: 1;
  overflow: hidden;
}

.element-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.element-icon :deep(svg) {
  max-width: 16px;
  max-height: 16px;
}

.element-label {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-arrow {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.dropdown-list {
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  width: 100%;
  min-width: 200px;
  border: 1px solid #C4C4C4;
  border-top: none;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  padding-top: 4px;
  background: white;
  background-clip: content-box;
}

.scroll-area {
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 4px 4px 4px;
}

.category-divider {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 0 2px 0;
}

.divider-line {
  flex: 1;
  height: 1px;
  background: #E0E0E0;
}

.category-label {
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #999;
  text-align: center;
  white-space: nowrap;
}

.dropdown-option {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 2px 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  border-radius: 4px;
  transition: background 0.2s;
}

.dropdown-option:hover {
  background: #F2F2F2;
}
</style>
